/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ページのタイプ（入力画面、確認画面、完了画面、非公開画面etc...）
 */
export type FormPageType = 'INPUT' | 'CONFIRM' | 'COMPLETE' | 'PRIVATE' | 'AUTHENTICATION' | 'RECEPTION_COMPLETE' | 'RECEPTION_AUTHENTICATION_ERROR';

export const FormPageType = {
    Input: 'INPUT' as FormPageType,
    Confirm: 'CONFIRM' as FormPageType,
    Complete: 'COMPLETE' as FormPageType,
    Private: 'PRIVATE' as FormPageType,
    Authentication: 'AUTHENTICATION' as FormPageType,
    ReceptionComplete: 'RECEPTION_COMPLETE' as FormPageType,
    ReceptionAuthenticationError: 'RECEPTION_AUTHENTICATION_ERROR' as FormPageType
};

